<template>
    <div>
        <loadStateView :state="netState" :refreshHandle="refreshData"/>
        <div v-if="netState == 0">
          <div class="sortMenu">
            <div class="btnList">
                <div class="btn" v-for="(item, index) in sortMenu" :key="index" @click="handle(index)" v-bind:class=" selectedIndex==index ? 'selBackground' : 'btn' " :style="drawBtnListLine(index)">
                {{item.sortname}}
                </div>
            </div>
            </div>
            <div class="sectionTitle">{{ $t('stats.goalDifferenceTitle') }}</div>
            <div class="statsBarsDiv">
              <statsBar :total="scoreStatistics[selectedIndex][0]" :occupy="scoreStatistics[selectedIndex][1]" :occupyColor="'#ff5a5e'" :statsTitle="this.$t('stats.goalDifference') + '2+'"/>
              <statsBar :total="scoreStatistics[selectedIndex][2]" :occupy="scoreStatistics[selectedIndex][3]" :occupyColor="'#ff5a5e'" :statsTitle="this.$t('stats.goalDifference') + '1'"/>
              <statsBar :total="scoreStatistics[selectedIndex][4]" :occupy="scoreStatistics[selectedIndex][5]" :occupyColor="'#3a6efe'" :statsTitle="this.$t('stats.draw')"/>
              <statsBar :total="scoreStatistics[selectedIndex][8]" :occupy="scoreStatistics[selectedIndex][9]" :occupyColor="'#46b070'" :statsTitle="this.$t('stats.netNegative') + '2'"/>
              <statsBar :total="scoreStatistics[selectedIndex][6]" :occupy="scoreStatistics[selectedIndex][7]" :occupyColor="'#46b070'" :statsTitle="this.$t('stats.netNegative') + '1'"/>
            </div>
            <div class="sectionTitle">{{ $t('stats.goalTitle') }}</div>
            <div class="statsBarsDiv">
              <statsBar :total="scoreStatistics[selectedIndex][10]" :occupy="scoreStatistics[selectedIndex][11]" :occupyColor="'#3a6efe'" :statsTitle="this.$t('stats.goalCount') + '0'"/>
              <statsBar :total="scoreStatistics[selectedIndex][12]" :occupy="scoreStatistics[selectedIndex][13]" :occupyColor="'#3a6efe'" :statsTitle="this.$t('stats.goalCount') + '1'"/>
              <statsBar :total="scoreStatistics[selectedIndex][14]" :occupy="scoreStatistics[selectedIndex][15]" :occupyColor="'#3a6efe'" :statsTitle="this.$t('stats.goalCount') + '2'"/>
              <statsBar :total="scoreStatistics[selectedIndex][16]" :occupy="scoreStatistics[selectedIndex][17]" :occupyColor="'#3a6efe'" :statsTitle="this.$t('stats.goalCount') + '3+'"/>
            </div>
            <div class="sectionTitle">{{ $t('stats.handicapTitle') }}</div>
            <div class="statsBarsDiv">
              <statsBar :total="handicapStatistics[selectedIndex][0]" :occupy="handicapStatistics[selectedIndex][1]" :occupyColor="'#ff5a5e'" :statsTitle="this.$t('stats.homeHandicap') + this.$t('stats.win1')"/>
              <statsBar :total="handicapStatistics[selectedIndex][2]" :occupy="handicapStatistics[selectedIndex][3]" :occupyColor="'#3a6efe'" :statsTitle="this.$t('stats.homeHandicap') + this.$t('stats.draw1')"/>
              <statsBar :total="handicapStatistics[selectedIndex][4]" :occupy="handicapStatistics[selectedIndex][5]" :occupyColor="'#46b070'" :statsTitle="this.$t('stats.homeHandicap') + this.$t('stats.lose1')"/>
              <statsBar :total="handicapStatistics[selectedIndex][6]" :occupy="handicapStatistics[selectedIndex][7]" :occupyColor="'#ff5a5e'" :statsTitle="this.$t('stats.guestHandicap') + this.$t('stats.win1')"/>
              <statsBar :total="handicapStatistics[selectedIndex][8]" :occupy="handicapStatistics[selectedIndex][9]" :occupyColor="'#3a6efe'" :statsTitle="this.$t('stats.guestHandicap') + this.$t('stats.draw1')"/>
              <statsBar :total="handicapStatistics[selectedIndex][10]" :occupy="handicapStatistics[selectedIndex][11]" :occupyColor="'#46b070'" :statsTitle="this.$t('stats.guestHandicap') + this.$t('stats.lose1')"/>
              <statsBar :total="handicapStatistics[selectedIndex][12]" :occupy="handicapStatistics[selectedIndex][13]" :occupyColor="'#ff5a5e'" :statsTitle="this.$t('stats.drawHandicap') + this.$t('stats.win1')"/>
              <statsBar :total="handicapStatistics[selectedIndex][14]" :occupy="handicapStatistics[selectedIndex][15]" :occupyColor="'#3a6efe'" :statsTitle="this.$t('stats.drawHandicap') + this.$t('stats.draw1')"/>
              <statsBar :total="handicapStatistics[selectedIndex][16]" :occupy="handicapStatistics[selectedIndex][17]" :occupyColor="'#46b070'" :statsTitle="this.$t('stats.drawHandicap') + this.$t('stats.lose1')"/>
            </div>
            <div class="sectionTitle">{{ $t('stats.goalStatsTitle') }}</div>
            <div class="goalStatsDiv">
              <div>
                <div>
                  <div class="goalCount">{{scoreTotal[0]}}</div>
                  <div class="goalCountTitle">0-1{{ this.$t('stats.ball') }}</div>
                </div>
                <div class="vl"/>
                <div>
                  <div class="goalCount">{{scoreTotal[1]}}</div>
                  <div class="goalCountTitle">2-3{{ this.$t('stats.ball') }}</div>
                </div>
                <div class="vl"/>
                <div>
                  <div class="goalCount">{{scoreTotal[2]}}</div>
                  <div class="goalCountTitle">4-6{{ this.$t('stats.ball') }}</div>
                </div>
                <div class="vl"/>
                <div>
                  <div class="goalCount">{{scoreTotal[3]}}</div>
                  <div class="goalCountTitle">≥7{{ this.$t('stats.ball') }}</div>
                </div>
              </div>
              <div>
                <div>
                  <div class="goalCount">{{scoreTotal[4]}}</div>
                  <div class="goalCountTitle">{{ this.$t('stats.single') }}</div>
                </div>
                <div class="vl"/>
                <div>
                  <div class="goalCount">{{scoreTotal[5]}}</div>
                  <div class="goalCountTitle">{{ this.$t('stats.double') }}</div>
                </div>
                <div/><div/><div/><div/><div/>
              </div>
            </div>
            <hr class="line"/>
        </div>
    </div>
</template>

<script>
import statsBar from '../components/statsBar'
export default {
  components: {
    statsBar
  },
  props: {
    teamId: {
      type: String,
      required: true
    }
  },
  watch: {
    teamId (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.loadData()
      }
    }
  },
  mounted () {
    this.loadData()
  },
  activated () {
    this.loadData()
  },
  methods: {
    loadData: function () {
      this.netState = 1
      this.$ft_getTeamStatistics(this.$route.params.teamId).then(result => {
        this.netState = result.netState
        this.scoreTotal = result.scoreTotal
        this.scoreStatistics = [result.scoreStatistics.total, result.scoreStatistics.home, result.scoreStatistics.neutral, result.scoreStatistics.away]
        this.handicapStatistics = [result.handicapStatistics.total, result.handicapStatistics.home, result.handicapStatistics.neutral, result.handicapStatistics.away]
      }).catch((error) => {
        this.netState = 2
        console.log('error:', error)
      })
    },
    refreshData () {
      this.loadData()
    },
    handle: function (index) {
      this.selectedIndex = index
    },
    drawBtnListLine: function (index) {
      if (index === 0) {
        return { 'border-left-style': 'none' }
      } else {
        return { 'border-left-style': 'solid', 'border-left-width': '1px', 'border-left-color': '#06b782' }
      }
    }
  },
  data () {
    return {
      netState: 0,
      sortMenu: [
        { sortname: this.$t('stats.total') },
        { sortname: this.$t('stats.home') },
        { sortname: this.$t('stats.neutralCourt') },
        { sortname: this.$t('stats.away') }
      ],
      selectedIndex: 0,
      scoreStatistics: [
        ['0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0'], // 总统计（数组位数）[淨勝2+,淨勝2+百分比,淨勝1,淨勝1百分比,平,平百分比,淨負1,淨負1百分比,淨負2+,淨負2+百分比,進球數0,進球數0百分比,進球數1,進球數1百分比,進球數2,進球數2百分比,進球數3+,進球數3+百分比]
        ['0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0'], // 主场统计（数组位数）[淨勝2+,淨勝2+百分比,淨勝1,淨勝1百分比,平,平百分比,淨負1,淨負1百分比,淨負2+,淨負2+百分比,進球數0,進球數0百分比,進球數1,進球數1百分比,進球數2,進球數2百分比,進球數3+,進球數3+百分比]
        ['0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0'], // 客场统计（数组位数）[淨勝2+,淨勝2+百分比,淨勝1,淨勝1百分比,平,平百分比,淨負1,淨負1百分比,淨負2+,淨負2+百分比,進球數0,進球數0百分比,進球數1,進球數1百分比,進球數2,進球數2百分比,進球數3+,進球數3+百分比]
        ['0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0'] // 中立场统计（数组位数）[淨勝2+,淨勝2+百分比,淨勝1,淨勝1百分比,平,平百分比,淨負1,淨負1百分比,淨負2+,淨負2+百分比,進球數0,進球數0百分比,進球數1,進球數1百分比,進球數2,進球數2百分比,進球數3+,進球數3+百分比]
      ],
      handicapStatistics: [
        ['0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0'], // 总统计（数组位数）[让球赢,让球赢百分比,让球走,让球走百分比,让球输,让球输百分比,受让赢,受让赢百分比,受让走,受让走百分比,受让输,受让输百分比,让平赢,让平赢百分比,让平走,让平走百分比,让平输,让平输百分比]
        ['0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0'], // 主场统计（数组位数）[让球赢,让球赢百分比,让球走,让球走百分比,让球输,让球输百分比,受让赢,受让赢百分比,受让走,受让走百分比,受让输,受让输百分比,让平赢,让平赢百分比,让平走,让平走百分比,让平输,让平输百分比]
        ['0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0'], // 客场统计（数组位数）[让球赢,让球赢百分比,让球走,让球走百分比,让球输,让球输百分比,受让赢,受让赢百分比,受让走,受让走百分比,受让输,受让输百分比,让平赢,让平赢百分比,让平走,让平走百分比,让平输,让平输百分比]
        ['0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0'] // 中立场统计（数组位数）[让球赢,让球赢百分比,让球走,让球走百分比,让球输,让球输百分比,受让赢,受让赢百分比,受让走,受让走百分比,受让输,受让输百分比,让平赢,让平赢百分比,让平走,让平走百分比,让平输,让平输百分比]
      ],
      scoreTotal: ['0', '0', '0', '0', '0', '0', '0'] // 总进球数、单双统计（数组位数）[0-1球,2-3球,2-3球,4-6球,7球或以上,單數,雙數]
    }
  }
}
</script>

<style lang="sass" scoped>
@import "style"
</style>
